import React, { lazy } from "react";
import Loadable from "../components/Loadable";
import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";


const OperatorCalendar = Loadable(lazy(() => import("../views/operatorSchedule/OperatorSchedule")))

const operatorShcedulePaths = routeCheck(
    [ 
       { path: "/operatorSchedule/list", element: <OperatorCalendar/>, auth: authRoles.permitAll},
    ], 
    false 
)

export default operatorShcedulePaths